<template>
  <v-container fluid>
    <h2>{{ $t('create_a_product') }}</h2>
    <product-form @saved="productCreated($event)"></product-form>
  </v-container>
</template>

<script>
import ProductForm from './ProductForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  components: {ProductForm},
  mixins: [BrowserUtilitiesMixin],
  mounted() {
    this.updateBrowserTitle(this.$t('create_product'))
  },
  methods: {
    productCreated(product) {
      this.$router.push('/product/' + product.id, () => {
        this.$store.dispatch(
          'globalMessagingModule/showSuccessFlashBanner',
          `${this.$i18n.tc('product')} ${this.$i18n.t('generic_save_success')}`
        )
      })
    }
  }
}
</script>

<style>
</style>
